// extracted by mini-css-extract-plugin
export var Panel = "Panel-module--Panel--Gihf7";
export var PanelCarousel = "Panel-module--Panel--carousel--1nHxU";
export var PanelActive = "Panel-module--Panel--active--1TTfz";
export var Panel__copyContainer = "Panel-module--Panel__copyContainer--oYs4a";
export var Panel__close = "Panel-module--Panel__close--3SDYu";